import React from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    Route,
    Routes,
    // Link
} from "react-router-dom";
import Header from '../common/header/Header'
import Home from '../Home';
import Footer from '../common/footer/Footer';
import Shop from '../Shop';
import ShopDetail from '../ShopDetail';
import Testimonial from '../testimonial/Testimonial';
import TestimonialMain from '../testimonial/TestimonialMain';
import Error from '../Error';
import Contact from '../Contact';
import Cart from '../Cart';
import Checkout from '../Checkout';
import Login from '../Login';
import Signup from '../Signup';
import ThankYou from '../thank-you';
import BlogPreview from '../blogs/BlogPreview';
import ScrollToTop from '../ScrollToTop';
import Account from '../Account';
import Privacy from '../../other/privacy';
import Shipping from '../../other/shipping';
import Refund from '../../other/refund';
import Terms from '../../other/terms';
import Cookie from '../../other/cookie';
import Sell from '../../other/sell';
import Request from '../../other/request';
import Embroider from '../../other/embroider';
import Contactus from '../../other/contactus';
import OrderIssue from '../../other/orderissue';
import Guaranteed from '../../other/guaranteed';
import FAQ from '../../other/faq';
import About from '../../other/about';

import BlogList from '../blogs/BlogList';
import ShopAll from '../ShopAll';
import { FaQ } from 'react-icons/fa6';
import InstantQuoteWidget from '../../other/InstantQuoteWidget';
import { BrandProvider } from '../../context/BrandContext';



const Pages = () => {
    return (
        <>
            <BrandProvider>

            <Router>
                <InstantQuoteWidget/>
            <ScrollToTop/>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />}></Route>
      <Route path="/product/:categoryName/:categoryId" element={<Shop />} />
          <Route path="/products" element={<ShopAll />} />

<Route
  path="/product/:categoryName/:categoryId/:productName/:productId"
  element={<ShopDetail />}
/>


                    <Route path="/testimonial" element={<TestimonialMain />}></Route>
                    <Route path="/cart" element={<Cart />}></Route>
                         <Route path="/account" element={<Account />}></Route>
                    <Route path="/checkout" element={<Checkout />}></Route>
                         <Route path="/login" element={<Login />}></Route>
                    <Route path="/signup" element={<Signup />}></Route>



                              <Route path="/blogs" element={<BlogList />}></Route>
        <Route path="/blogs/:slug" element={<BlogPreview />} />
                    <Route path="/*" element={<Error />}></Route>
                    <Route path="/contact" element={<Contact />}></Route>
                             <Route path="/thank-you" element={<ThankYou />}></Route>
                             <Route path="/privacy-policy" element={<Privacy />} />
                             <Route path="/shipping-policy" element={<Shipping />} />
                             <Route path="/refund-policy" element={<Refund />} />
                             <Route path="/terms-of-service" element={<Terms />} />
                             <Route path="/cookie-policy" element={<Cookie />} />
                             <Route path="/do-not-sell" element={<Sell />} />
                             <Route path="/data-request" element={<Request />} />
                             <Route path="/embroidercraft-studio" element={<Embroider />} />
                             <Route path="/contact-us" element={<Contactus />} />
                             <Route path="/order-issue-form" element={<OrderIssue />}/>
                             <Route path="/guaranteed-satisfaction" element={<Guaranteed />}/>
                             <Route path="/faq" element={<FAQ />} />
                             <Route path="/about-us" element={<About />} />

                </Routes>
                <Footer />
            </Router>
                </BrandProvider>

        </>
    )
}

export default Pages
